import axios from 'src/api/Api';
import {
    ALLOCATE_SET_SUCCESS,
    ALLOCATE_SET_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* allocateSetSaga(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const {
        batchCurrentAccount = '',
        batchId,
        batchType = '',
        checkSurgery,
        sapLineNo,
        sapOrderNo,
        setNo,
    } = action.payload || {};

    const queryParams = convertObjectToQueryParams({
        batchCurrentAccount,
        batchId,
        batchType,
        checkSurgery,
        sapLineNo,
        sapOrderNo,
        setNo,
    });

    const url = `/occ/v2/${baseSiteId}/dashboard/allocateSet?${queryParams}`;

    try {
        const result = yield axios
            .post(url)
            .then((response) => response.data);

        yield put({
            type: ALLOCATE_SET_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });

        yield put({
            type: ALLOCATE_SET_FAILURE,
            payload: errorHandler(error?.response?.status || '503'),
        });
    }
}
